// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Farm View Map Styles */

.farm-view-map {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: var(--color-grey-99);
  background-color: var(--color-grey-99);
  border-radius: 8px;
  overflow: hidden;
}

.farm-view-map__controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
  gap: 24px;
}

.farm-view-map__legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.farm-view-map__legend-items {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.farm-view-map__legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.farm-view-map__legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.farm-view-map__ndvi-toggle {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.farm-view-map__ndvi-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.farm-view-map__ndvi-slider {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border-radius: 12px;
  transition: background-color 0.3s ease;
}

.farm-view-map__ndvi-slider::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  left: 2px;
  top: 2px;
  background-color: var(--color-grey-100);
  background-color: var(--color-grey-100);
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.farm-view-map__ndvi-toggle input:checked + .farm-view-map__ndvi-slider {
  background-color: var(--color-primary-idel);
  background-color: var(--color-primary-idel);
}

.farm-view-map__ndvi-toggle
  input:checked
  + .farm-view-map__ndvi-slider::before {
  transform: translateX(20px);
}

.farm-view-map__container {
  flex: 1;
  position: relative;
  min-height: 400px;
}

.farm-view-map__help {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.farm-view-map__help kbd {
  padding: 2px 6px;
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
  color: var(--color-grey-34);
  color: var(--color-grey-34);
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/FarmViewMap.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,6CAA6C;EAC7C,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;AAC7B","sourcesContent":["/* Farm View Map Styles */\n\n.farm-view-map {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: var(--color-grey-99);\n  background-color: var(--color-grey-99);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.farm-view-map__controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: var(--color-grey-100);\n  background-color: var(--color-grey-100);\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: 1px solid var(--color-grey-91);\n  gap: 24px;\n}\n\n.farm-view-map__legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.farm-view-map__legend-items {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.farm-view-map__legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.farm-view-map__legend-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n}\n\n.farm-view-map__ndvi-toggle {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  padding: 8px 16px;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.farm-view-map__ndvi-toggle input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.farm-view-map__ndvi-slider {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: var(--color-grey-91);\n  background-color: var(--color-grey-91);\n  border-radius: 12px;\n  transition: background-color 0.3s ease;\n}\n\n.farm-view-map__ndvi-slider::before {\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: 2px;\n  top: 2px;\n  background-color: var(--color-grey-100);\n  background-color: var(--color-grey-100);\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n.farm-view-map__ndvi-toggle input:checked + .farm-view-map__ndvi-slider {\n  background-color: var(--color-primary-idel);\n  background-color: var(--color-primary-idel);\n}\n\n.farm-view-map__ndvi-toggle\n  input:checked\n  + .farm-view-map__ndvi-slider::before {\n  transform: translateX(20px);\n}\n\n.farm-view-map__container {\n  flex: 1;\n  position: relative;\n  min-height: 400px;\n}\n\n.farm-view-map__help {\n  position: absolute;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 16px;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n}\n\n.farm-view-map__help kbd {\n  padding: 2px 6px;\n  background-color: var(--color-grey-96);\n  background-color: var(--color-grey-96);\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 11px;\n  color: var(--color-grey-34);\n  color: var(--color-grey-34);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
